import { BlobServiceClient, ContainerClient } from '@azure/storage-blob';
import { AzureBlob, UserProfileInfo } from '../types';

const containerName = `medias`;
const mediaUrl = process.env.REACT_APP_MEDIA_URL;
const blobServiceBaseUrl = mediaUrl ? new URL(mediaUrl).origin : '';

const getBlobServiceClient = (sasUrl: string) =>
    new BlobServiceClient(`${blobServiceBaseUrl}/${sasUrl.replace(/^\/+/, '')}`);

const createBlobInContainer = async (containerClient: ContainerClient, file: File, Id: string, imagesCount: number, setAsProfilePhoto: boolean, blobName: string) => {

    const options = { blobHTTPHeaders: { blobContentType: file.type } };
    const getBlobClient = (suffix = '') => containerClient.getBlockBlobClient(`${Id}${suffix}`);

    if (Id === blobName || `${Id}T` === blobName) {

        if (setAsProfilePhoto) {
            const blobClient = getBlobClient(blobName === Id ? '' : 'T');
            await blobClient.uploadData(file, options);
        }
    }
    else {
        imagesCount++;
        const imageName = `${Id}${imagesCount}`;
        if (imageName === blobName || `${imageName}T` === blobName) {
            const blobClient = getBlobClient(blobName === imageName ? `${imagesCount}` : `${imagesCount}T`);
            await blobClient.uploadData(file, options);
        }
    }
    return imagesCount;
};

const uploadFileToBlob = async (file: File | null, sasTokenJson: string, profileId: string, imagesCount: number, setAsProfilePhoto: boolean, userProfileInfo: UserProfileInfo[] | null) => {

    const azureBlobs: AzureBlob[] = JSON.parse(sasTokenJson);

    if (!setAsProfilePhoto) {

        if (userProfileInfo) {

            userProfileInfo[0].CountProfilePictures++;
            const filteredBlobs: AzureBlob[] = azureBlobs.filter(blob => blob.id === `${profileId}${userProfileInfo[0].CountProfilePictures}` || blob.id === `${profileId}${userProfileInfo[0].CountProfilePictures}T`);

            for (const azureBlob of filteredBlobs) {

                const blobService = getBlobServiceClient(azureBlob.sasUrl);

                if (file) {
                    const containerClient = blobService.getContainerClient(containerName);
                    const imgCount = await createBlobInContainer(containerClient, file, profileId, imagesCount, setAsProfilePhoto, azureBlob.id);

                    if (azureBlob.id === filteredBlobs[1].id) {
                        return imgCount;
                    }
                }
            }
        }

    } else {

        for (const azureBlob of azureBlobs) {

            const blobService = getBlobServiceClient(azureBlob.sasUrl);

            if (file) {
                const containerClient = blobService.getContainerClient(containerName);
                const imgCount = await createBlobInContainer(containerClient, file, profileId, imagesCount, setAsProfilePhoto, azureBlob.id);

                if (azureBlob.id === azureBlobs[3].id) {
                    return imgCount;
                }
            }
        }
    }
    return;
};

export default uploadFileToBlob; 

const createBlobInContainerForImages = async (file: File, containerClient: ContainerClient, blobName: string) => {
    const options = { blobHTTPHeaders: { blobContentType: file.type } };
    const blobClient = containerClient.getBlockBlobClient(blobName);
    await blobClient.uploadData(file, options);
}

export const uploadImageToStorage = async (file: File | null, azureBlobs: AzureBlob[]) => {

    for (const azureBlob of azureBlobs) {

        const blobService = getBlobServiceClient(azureBlob.sasUrl);

        if (file) {
            const containerClient = blobService.getContainerClient(containerName);
            await createBlobInContainerForImages(file, containerClient, azureBlob.id);
        }
    }
}
